import { render, staticRenderFns } from "./a36.vue?vue&type=template&id=36a2d468&scoped=true"
import script from "./a36.vue?vue&type=script&lang=js"
export * from "./a36.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2d468",
  null
  
)

export default component.exports